<template>
  <div>
    <div class="w-full pb-4 xl:pb-6">
      <Navigation :step="2" />

      <div v-if="!redemptionUltimateFailureReason" class="w-full viewport-gutter">
        <div class="container">
          <div class="text-sm xl:text-lg">
            <h1 class="pb-2 text-xl font-bold leading-tight uppercase xl:text-3.25xl text-sn-secondary">
              {{ $t('pages.redemption.title') }}
            </h1>
            <p v-if="!loading || errors.length" class="leading-tight">
              {{ $t('pages.redemption.subtitle') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="redemptionUltimateFailureReason">
      <p class="max-w-sm pt-6 mx-auto text-center xl:pt-12">
        {{ $t(`errors.type.${errors[0]}.title`, brandInfo) }}
        <br>
        {{ $t(`errors.type.${errors[0]}.description`, brandInfo) }}
      </p>
      <p class="max-w-sm pt-2 mx-auto text-center">
        {{ $t('components.payment.beforeCancellationRedirect', brandInfo) }}
      </p>
    </Loading>

    <div v-else-if="redemption.id" class="pt-6 pb-16 viewport-gutter xl:pt-8 xl:pb-24">
      <div class="container">
        <div class="w-full max-w-xl m-0">
          <RouterView />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Redemption from '~psp-pages/base/redemption/redemption.ts'

import Navigation from '~app/psp/brussels/navigation.vue'
import Loading from '~brand-components/brussels/loading/loading.vue'
import Summary from './summary.vue'

export default Redemption.extend({
  components: {
    Navigation,
    Summary,
    Loading,
  },
})
</script>
